import {TFunction} from "react-i18next";
import {ColumnsType} from "antd/lib/table/interface";
import React from "react";
import {Claim, ClaimStatus, ClaimType} from "../../../models/claims/claims";
import {Link} from "react-router-dom";
import {ClaimsStatus} from "../status/claim.status";
import {Date} from "../../core/commons/date/date";

export const columnsFactory = (t: TFunction<"translation">): ColumnsType<Claim> => {
    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id"
        },
        {
            title: t("TYPE"),
            dataIndex: "type",
            key: "type",
            render: (type: ClaimType) => t("CLAIMS.CLAIM.TYPE." + type.toUpperCase()),
        },
        {
            title: t("NUMBER"),
            dataIndex: "documentNumber",
            key: "documentNumber",
            render: (number: number, claim) => <Link to={"/claims/" + claim.id}>{number}</Link>,
        },
        {
            title: t("STATUS"),
            dataIndex: "status",
            key: "status",
            width: "125px",
            render: (item: ClaimStatus) => <ClaimsStatus status={item} />
        },
        // {
        //     title: t("TOTAL_AMOUNT"),
        //     dataIndex: "grandTotal",
        //     key: "grandTotal",
        //     render: (item: Amount) => displayPrice(item)
        // },
        {
            title: t("DATE"),
            dataIndex: "documentDate",
            key: "documentDate",
            render: (item: string) => <Date dateString={item} showTime />
        }
    ];
}